/* eslint-disable prettier/prettier */
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import theme from '../../../../../../../../styles/theme';
import convertToRealWithChecked, {
  convertToReal,
} from '../../../../../../../../utils/values';
import AccountingDivisor from '../../../AccountingDivisor';
import Text from '../Text';

function UnifiedReportOfFiducia() {
  const accountingAppContext = useSelector(
    (reducer: IReducer) => reducer.accountingAppV2
  );

  return (
    <>
      <Text.Title>
        De {moment(accountingAppContext.dateSearch.start).format('DD/MM/YY')}{' '}
        até {moment(accountingAppContext.dateSearch.end).format('DD/MM/YY')}
      </Text.Title>
      <Text.Title>Contas da Fidúcia</Text.Title>
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        padding="0 0 2rem"
        color={theme.colors.mainColor}>
        <Text.MainLabel>Saldo Inicial: </Text.MainLabel>
        <Text.MainLabel>
          {convertToReal(
            convertToRealWithChecked(accountingAppContext.fiducia.saldo_inicial)
          )}
        </Text.MainLabel>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>TEDs</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.teds.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.teds.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Pix</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.pix.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.pix.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Tarifas Pagas à Fiducia</Text.LabelU>
        <Text.LabelU>-</Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.tarifas_pagas_a_fiducia
                .valor_enviado
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Tarifas pagas (PIX/TED/Outras)</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.tarifas_pagas.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.tarifas_pagas_a_wl.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Pagamento de Contas Celcoin</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.pagamentos_celcoin.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.pagamentos_celcoin.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>FGTS</Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.fgts.valor_recebido
            )
          )}
        </Text.LabelU>
        <Text.LabelU>-</Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Investimento</Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.investimento.valor_recebido
            )
          )}
        </Text.LabelU>
        <Text.LabelU>-</Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Recebimento de TEV Interna</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.recebimento_tev_interna.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.recebimento_tev_interna
                .valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Domicílio Bancário</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.domicilio_bancario.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.domicilio_bancario.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Boleto</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.boletos_liquidados.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.boletos_liquidados.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Cartão</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.cartao.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.cartao.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Cripto</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.cripto.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.fiducia.cripto.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        margin="1rem 0 1rem"
        color={theme.colors.mainColor}>
        <Text.MainLabel>Saldo Final: </Text.MainLabel>
        <Text.MainLabel>
          {convertToReal(
            convertToRealWithChecked(accountingAppContext.fiducia.saldo_final)
          )}
        </Text.MainLabel>
      </Wrapper.Default>
      <Text.Title>Contas de Clientes</Text.Title>
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        margin="2rem 0 1.5rem"
        color={theme.colors.mainColor}>
        <Text.MainLabel>Saldo Inicial: </Text.MainLabel>
        <Text.MainLabel>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.saldo_inicial
            )
          )}
        </Text.MainLabel>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>TEDs</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.teds.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.teds.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Pix</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.pix.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.pix.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Tarifas Pagas à Fiducia</Text.LabelU>
        <Text.LabelU>-</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.tarifas_pagas_a_fiducia
                .valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>-</Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Tarifas Pagas à WL</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.tarifas_pagas_a_wl.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.tarifas_pagas_a_wl.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Pagamento de Contas Celcoin</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.pagamentos_celcoin.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.pagamentos_celcoin.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Recebimento de TEV Interna</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.recebimento_tev_interna
                .valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.recebimento_tev_interna
                .valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Domicílio Bancário</Text.LabelU>
        <Text.LabelU>-</Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.domicilio_bancario.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Boleto</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.boletos_liquidados.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.boletos_liquidados.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>TEVs</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.tev_entre_ambiente.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.tev_entre_ambiente.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Cartão</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.cartao.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.cartao.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <AccountingDivisor />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        width="100%">
        <Text.LabelU>Cripto</Text.LabelU>
        <Text.LabelU>
          Valor Enviado:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.cripto.valor_enviado
            )
          )}
        </Text.LabelU>
        <Text.LabelU>
          Valor Recebido:
          <br />
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.terceiros.cripto.valor_recebido
            )
          )}
        </Text.LabelU>
      </Wrapper.Default>
      <Wrapper.Default
        isActive
        margin="2rem 0 2rem"
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        padding="2rem 0"
        color={theme.colors.mainColor}>
        <Text.MainLabel>Saldo Final:</Text.MainLabel>
        <Text.MainLabel>
          {convertToReal(
            convertToRealWithChecked(accountingAppContext.fiducia.saldo_final)
          )}
        </Text.MainLabel>
      </Wrapper.Default>
    </>
  );
}

export default UnifiedReportOfFiducia;
